import { FAQPageJsonLd, NextSeo } from 'next-seo'
import NavBar from '@components/common/navbar'
import FirstFold from '@components/reviews-and-testimonials/first-fold'
import { formatSeoConfig } from '@lib/seo'
import VideoTestimonial from '@components/locale-pages/home/video-testimonial'
import { Trans } from '@lingui/macro'
import { VIDEO_TESTIMONIAL } from '@lib/data/summer-coding-camp'
import TrustpilotReview from '@components/locale-pages/home/trustpilot-review'
import TestimonialsFold from '@components/landing-page/geo-landing-page/testimonials'
import Footer from '@components/common/footer'
import {
  REVIEW_PARENT_TESTIMONIAL,
  REVIEW_STUDENT_TESTIMONIAL,
} from '@lib/data/testimonials'
import StudentImpact from '@components/about-us/student-impact'
import Courses from '@components/about-us/courses'
import AboutTeachers from '@components/about-us/about-teachers'
import Stories from '@components/about-us/stories'
import { Investors } from '@components/book-trial-class-jp/investors'
import StudentProjects from '@components/home/student-projects-fold'
import { TESTIMONIAL_STUDENT_PROJECTS } from '@lib/data/home-student-projects'
import Faq from '@components/home/faq'
import { REVIEWS_AND_TESTIMONIALS_FAQ } from '@lib/data/faq'
import BannerCard from '@components/reviews-and-testimonials/banner-card'
import AboutUsCard from '@components/reviews-and-testimonials/about-us-card'
import TrustedByParents from '@components/teacher-lp/trusted-by-parents'
import TrustedByFamilies from '@components/reviews-and-testimonials/trusted-by-families'

const reviewTestimonialsSeo = formatSeoConfig({
  title:
    'Codingal Testimonials | Real Parent and Student Reviews for K–12 Learning',
  description:
    'Wondering what Codingal is like? Read real parent and student reviews, teacher feedback, and community testimonials. Explore Trustpilot and Google reviews, student projects, and impact videos across K–12 learning paths.',
  url: 'https://www.codingal.com/reviews-and-testimonials/',
  metaImage:
    'https://fastly.codingal.com/images/reviews-and-testimonials/og-image.jpg',
})

const ReviewTestimonials = () => (
  <>
    <NextSeo {...reviewTestimonialsSeo} />
    <FAQPageJsonLd
      mainEntity={REVIEWS_AND_TESTIMONIALS_FAQ.map(
        ({ acceptedAnswerText, questionName }) => ({
          acceptedAnswerText: acceptedAnswerText,
          questionName: questionName,
        })
      )}
    />
    <NavBar isSticky={true} />
    <FirstFold />
    <TrustedByFamilies />
    <div style={{ backgroundColor: '#F4FAFF' }} className="pb-4">
      <VideoTestimonial
        title={
          <Trans>
            Students and parents love Codingal’s training program and curriculum
          </Trans>
        }
        video_testimonial={VIDEO_TESTIMONIAL}
      />
      <TrustpilotReview showReviewLink={false} ctaSize="md" />
    </div>
    <StudentImpact />
    <TrustedByParents ctaSize="md" />
    <TestimonialsFold
      customTestimonials={REVIEW_STUDENT_TESTIMONIAL}
      title={<Trans>Stories from our student community</Trans>}
      description="Students reflect on fun learning moments, accomplishments and the excitement of trying new things."
      showReviewLink={false}
    />
    <StudentProjects
      title="See what learners are making"
      description="From first lines of code to full-fledged projects, students create, experiment and grow with every challenge."
      customProjects={TESTIMONIAL_STUDENT_PROJECTS}
      scaleOnHover={false}
      hideCta
    />
    <Courses />
    <div className="bg-opacity-25 bg-blue-50">
      <TestimonialsFold
        customTestimonials={REVIEW_PARENT_TESTIMONIAL}
        title={<Trans>Stories from our parent community</Trans>}
        description="Parents reflect on their child’s learning, achievements, and growing confidence."
        showReviewLink={false}
      />
    </div>
    <AboutTeachers />
    <div className="flex flex-col">
      <Stories background="linear-gradient(288.8deg, #FFFFFF -22.76%, #FFE5E1 48.11%, #FFFFFF 126.14%)" />
    </div>
    <BannerCard />
    <Faq
      faqContents={REVIEWS_AND_TESTIMONIALS_FAQ}
      title="Frequently Asked Questions"
      faqImage={{
        path: '/images/reviews-and-testimonials',
        alt: 'Review and Testimonials FAQ Image',
      }}
    />
    <div className="px-5 bg-blue-50 bg-opacity-25">
      <Investors hideCta />
    </div>
    <div className="pb-16">
      <AboutUsCard />
    </div>
    <Footer />
  </>
)

export default ReviewTestimonials
